import Image from 'next/image';

import { FeaturedTile } from 'components/Stage/FeaturedTile/FeaturedTile';

import { getCFImageWidthFromHeight } from 'lib/images/imageSizeHelper';

import type { Asset } from 'contentful';
import type {
  ILinkedComponent,
  ILinkedComponentFields,
  IStageLogo,
  IStagePartnerWithHeadline,
  IStagePartnerWithHeadlineFields,
} from 'types/generated/contentful';
import { Badge } from './Badge';
import Ekomi from 'components/Stage/Ekomi';
interface PartnerImageProps {
  image: Asset;
}

const PARTNER_IMAGE_HEIGHT = 25;

const PartnerImage = (props: PartnerImageProps) => {
  const { image } = props;
  const src = image.fields.file?.url?.toString();
  const alt = image.fields.description?.toString() || '';

  if (!src) return null;

  const height = PARTNER_IMAGE_HEIGHT;
  const width = getCFImageWidthFromHeight(image, height);

  return <Image src={src} height={height} width={width} alt={alt} />;
};

interface PartnerPanelProps {
  partner: IStagePartnerWithHeadline | IStageLogo | ILinkedComponent;
}

const PartnerPanel = (props: PartnerPanelProps) => {
  const { partner } = props;
  const { headline, images } =
    partner.fields as IStagePartnerWithHeadlineFields;
  return (
    <FeaturedTile title={headline!}>
      {images.map((image) => (
        <PartnerImage key={image.sys.id} image={image} />
      ))}
    </FeaturedTile>
  );
};

interface PartnerPanelsProps {
  partners:
    (IStagePartnerWithHeadline | IStageLogo | ILinkedComponent)[] | undefined;
}

export const PartnerPanels = (props: PartnerPanelsProps) => {
  const { partners } = props;

  if (!partners || partners.length === 0) {
    return null;
  }
  return partners.map((partner) => {
    const { id } = partner.sys.contentType.sys;
    if (id.toLowerCase() === 'stagelogo') {
      return <Badge key={partner.sys.id} content={partner as IStageLogo} />;
    }
    const { id: linkedComponent } = partner.sys.contentType.sys;
    if (linkedComponent === 'linkedComponent') {
      const {
        configurationJson: {
          data: { component },
        },
      } = partner.fields as ILinkedComponentFields;
      if (component === 'EkomiWidgetLink') {
        return <Ekomi key={partner.sys.id} />;
      }
      return null;
    }
    return <PartnerPanel key={partner.sys.id} partner={partner} />;
  });
};
